module.exports = __webpack_public_path__ + "img/__icon_PODKONTENEROWA_STANDARD_40.f6068604.svg";